import { useVehicleAccessories } from '@/core/domain/people/Accessory/Accessory.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Button, Select, SelectProps } from 'antd';
import { forwardRef } from 'react';
import Group from '../Group';
import {
  getAccessoryId,
  parseAccessoryId,
} from '../_VehicleModal/getAccessoryId';
import { queryClient } from '@/Root';

interface Props {
  useCachedData?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AccessoriesSelect = forwardRef<any, SelectProps & Props>((props, ref) => {
  const cachedData = props.useCachedData
    ? queryClient.getQueryData(['vehicles-acessories', { active: true }])
    : undefined;

  const { data, isLoading, isFetching, hasNextPage, fetchNextPage } =
    useVehicleAccessories({ active: true }, !cachedData);

  const accessories = flatInfiniteData(data)?.map((accessory) => ({
    value: getAccessoryId(accessory),
    label: accessory.description,
  }));

  let options = accessories;

  if (props.value && Array.isArray(props.value)) {
    options = [
      ...options,
      ...props.value
        .filter(
          (value) => !options.some((accessory) => accessory.value === value),
        )
        .map((value) => {
          const accessory = parseAccessoryId(value);
          return { value, label: accessory.description };
        }),
    ];
  }

  return (
    <Select
      ref={ref}
      {...props}
      style={{ ...props.style, width: '100%' }}
      mode={props.mode || 'multiple'}
      loading={props.loading || isLoading}
      showSearch
      optionFilterProp="label"
      options={options}
      dropdownRender={(menu) => (
        <>
          {menu}

          {hasNextPage && (
            <Group position="center" style={{ marginTop: 24 }}>
              <Button
                loading={isFetching}
                onClick={() => fetchNextPage()}
                type="link"
              >
                {isFetching ? 'Carregando' : 'Carregar mais'}
              </Button>
            </Group>
          )}
        </>
      )}
    />
  );
});

export default AccessoriesSelect;
